// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3Wbhf","header":"Messages_header__e5_ly"};